import Sheet from '@mui/joy/Sheet'
import Table from '@mui/joy/Table'
import Typography from '@mui/joy/Typography'
import { percent } from '../format'
import InfoHint from './InfoHint'

interface CountTableProps {
    title: string
    rows: { label: string; count: number }[]
    empty: string
    info?: string
}

/** A titled, count-sorted two-column table with each row's share. */
export default function CountTable({ title, rows, empty, info }: CountTableProps) {
    const total = rows.reduce((sum, r) => sum + r.count, 0)
    const sorted = [...rows].sort((a, b) => b.count - a.count)
    return (
        <Sheet variant="outlined" sx={{ borderRadius: 'md', p: 1.5, flex: '1 1 280px', minWidth: 0 }}>
            <Typography level="title-sm" sx={{ mb: 1 }}>
                {info ? <InfoHint hint={info}>{title}</InfoHint> : title}
            </Typography>
            {sorted.length === 0 ? (
                <Typography level="body-sm">{empty}</Typography>
            ) : (
                <Table size="sm" sx={{ '& td:last-child, & th:last-child': { textAlign: 'right' } }}>
                    <tbody>
                        {sorted.map((r) => (
                            <tr key={r.label}>
                                <td style={{ wordBreak: 'break-word' }}>{r.label}</td>
                                <td style={{ width: 120 }}>
                                    {r.count} <Typography level="body-xs">({percent(r.count, total)})</Typography>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Sheet>
    )
}
